import React from 'react';
import Stack from '@mui/material/Stack';
import { colors } from 'styles/colors';
import TypographyWithI18N from './TypographyWithI18N';
import { Box, Grid, Typography } from '@mui/material';
import { FeedbackDetailResponseSelectedOption } from 'models/enum';
import { formatToOneDecimal } from 'modules/hiring/utilities';

export interface IProficiencyDotsProps {
  rating?: string;
  showAvgRating?: boolean;
  count?: number;
  size?: string;
}

const ProficiencyDots = ({
  rating,
  showAvgRating,
  count,
  size,
}: IProficiencyDotsProps) => {
  return (
    <Stack
      direction='row'
      spacing={0.75}
      alignItems='center'
      justifyContent='center'
      height='1.25rem'
      id='proficiency-dots-container'
      data-testid='proficiency-dots-container'
    >
      {rating === FeedbackDetailResponseSelectedOption.NA ? (
        <TypographyWithI18N
          className='kfic2-bodyTextSmall'
          i18nKey='notApplicable'
          id='not-applicable'
          data-testid='not-applicable'
          noWrap
        />
      ) : (
        [...Array(count)].map((_, i) => {
          return (
            <Grid
              key={i}
              id={`proficiency-skill-containter-${i}`}
              data-testid={`proficiency-skill-containter-${i}`}
            >
              <Box
                sx={{
                  width: size ?? '0.875rem',
                  height: size ?? '0.875rem',
                  border: '1px solid transparent',
                  borderRadius: '50%',
                  background: `${
                    i < (rating ? parseInt(rating?.toString(), 10) : 0)
                      ? colors.tertiary.green
                      : colors.background.midGray
                  }`,
                }}
              />
            </Grid>
          );
        })
      )}
      {showAvgRating && (
        <Typography
          className='kfic2-bodyTextSmallBold'
          id={`avarage-skill-${rating}`}
          data-testid={`avarage-skill-${rating}`}
        >
          {rating === FeedbackDetailResponseSelectedOption.NA
            ? ''
            : formatToOneDecimal(rating!)}
        </Typography>
      )}
    </Stack>
  );
};

export default ProficiencyDots;
